import { render, staticRenderFns } from "./PaymentDetailsAndForm.vue?vue&type=template&id=2971c767&scoped=true"
import script from "./PaymentDetailsAndForm.vue?vue&type=script&lang=ts"
export * from "./PaymentDetailsAndForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDetailsAndForm.vue?vue&type=style&index=0&id=2971c767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971c767",
  null
  
)

export default component.exports